"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharedDialogTelemetry = void 0;
const TelemetryEvents_1 = require("./TelemetryEvents");
const TelemetrySender_1 = require("./TelemetrySender");
class SharedDialogTelemetry {
    constructor() {
        this.sendDataDisplayedInSharedDialog = (typeOfDataDisplayed, displayDuration, telemetryContext) => {
            TelemetrySender_1.telemetrySender.sendEvent({
                type: TelemetryEvents_1.TelemetryEvents.DataDisplayedInSharedDialog,
                typeOfDataDisplayed: typeOfDataDisplayed,
                displayDuration: displayDuration,
            }, telemetryContext, 'empty');
        };
    }
}
exports.sharedDialogTelemetry = new SharedDialogTelemetry();
//# sourceMappingURL=SharedDialogTelemetry.js.map